import SV from 'server-vars';
export default function(): string | null {
    if (typeof window === 'undefined') {
        return null;
    }
    // when on PROD, window.location.hostname is `www.1stdibs.com`
    // there is no subdomain of `adminv2.www.1stdibs.com`
    // this will work on all subdomains expect for `www`,
    // including mario and luigi where the SV.adminHost value is www.1stdibs.com
    let host = `https://adminv2.${window.location.hostname}`;
    if (host.includes('www')) {
        host = SV.get('adminHost');
    }
    return host;
}
